/* eslint-disable react/prop-types */
// Dependecies

import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { reject } from 'lodash';
import { useAccordionToggle } from 'react-bootstrap';
import * as moment from 'moment';
import PropTypes from 'prop-types';
// Store
import user from '../../store/user';
import maintenance from '../../store/maintenances';

// Hooks
import useLanguage from '../useLanguage';

function useStatusService() {

  const [t] = useTranslation('modal', { useSuspense: false });
  const [tMaintenance] = useTranslation('maintenance', { useSuspense: false });
  const [reload, setReload] = useState(false);
  const [maintenances, setMaintenances] = useState([]);
  const [newMaintenances, setNewMaintenances] = useState(0);
  const [, setMaintenancesBool] = useState(-1);
  const [loadingServices, setLoadingServices] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalCancel, setOpenModalCancel] = useState(false);
  const [openModalChangeInProcess, setOpenModalChangeInProcess] = useState(false);
  const [openModalChangeInApproval, setOpenModalChangeInApproval] = useState(false);
  const [openModalAdditionalApproval, setOpenModalAdditionalApproval] = useState(false);
  const dataFormAdditionalApprovalRef = useRef({});
  const idServiceRef = useRef(0);
  const [messageAlertAdditionalApproval, setMessageAlertAdditionalApproval] = useState(false);
  const [openModalSatisfactionQuestionnaire, setOpenModalSatisfactionQuestionnaire] = useState(false);
  const [openModalStars, setOpenModalStars] = useState(false);
  const [dataFormInApproval, setDataFormInApproval] = useState({});

  const [openModalLeft, setOpenModalLeft] = useState(false);
  const [openModalRequestReject, setOpenModalRequestReject] = useState(false);
  const [, setShowBtnOption] = useState(true);
  const [, setShowBtnCancel] = useState(true);
  const [idService, setIdService] = useState(0);
  const [userStore] = user();
  const [, maintenancesActions] = maintenance();
  const { locale } = useLanguage();
  const [dateInitial, useSetDateInitial] = useState(moment().subtract(1, 'years'));
  const [dateFinal, useSetDateFinal] = useState(moment());
  const [filterDate, useSetFilterDate] = useState(false);
  const [star, setStar] = useState(0);
  const [arrow, setArrow] = useState(false);
  const [activeKeyStatus, setActiveKeyStatus] = useState(0);
  const [messageAlert, setMessageAlert] = useState(false);
  const [messageAlertInApproval, setMessageAlertInApproval] = useState(false);
  const [textMessageAlertInApproval, setTextMessageAlertInApproval] = useState(t('maintenance'));
  const [messageQuestionnaire, setMessageQuestionnaire] = useState(false);
  const [dataMaintenance, useSetdataMaintenance] = useState(false);
  const [dataGarage, useSetDataGarage] = useState([]);

  useEffect(() => {
    if (userStore.token) {
      const data = {
        dateInitial: `${moment(dateInitial).format('YYYY-MM-DD')} 00:00:00`,
        dateFinal: `${moment(dateFinal).format('YYYY-MM-DD')} 23:00:00`,
      };
      maintenancesActions.setMaintenances(userStore.token, data, locale).then(
        (maintenancesResponse) => {
          useSetDataGarage(maintenancesResponse.service);
          setMaintenances(maintenancesResponse.service.services);
          setNewMaintenances(maintenancesResponse.read);
          setMaintenancesBool(maintenancesResponse.bool);
          setLoadingServices(false);
          useSetFilterDate(false);
          if (
            maintenancesResponse.service.services.length > 0 ||
            maintenancesResponse.read > 0 ||
            maintenancesResponse.bool > 0
          ) {
            useSetdataMaintenance(true);
          }
          setReload(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
          reject('Error');
        }
      );
    }
  }, [userStore.token, loadingServices, filterDate]);

  useEffect(() => {
    const time = setTimeout(() => {
      setMessageAlert(false);
    }, 10000);

    return () => {
      clearTimeout(time);
    };
  }, [messageAlert]);

  const closeModal = () => {
    setOpenModal(false);
    setOpenModalChangeInProcess(false);
    setOpenModalSatisfactionQuestionnaire(false);
    setOpenModalStars(false);
    setOpenModalRequestReject(false);
    setOpenModalLeft(false);
    setOpenModalCancel(false);
    setOpenModalChangeInApproval(false);
    setOpenModalAdditionalApproval(false);
    setMessageAlertAdditionalApproval(false);
  };

  function update(
    id,
    optionSelect,
    whyRejectIt,
    status,
    questionnaire,
    stars,
    read,
    companyObservations,
    companyStars,
    imagesFiles = null,
    kmOdometer = null,
    filesWorkshop = null,
    sistems = null,
  ) {
    const data = {
      id,
      option: optionSelect,
      whyRejectIt,
      status,
      questionnaire,
      stars,
      read,
      companyObservations,
      companyStars,
      imagesFiles,
      kmOdometer,
      filesWorkshop,
      sistems
    };

    if (userStore.token) {
      return maintenancesActions.update(userStore.token, data).then(
        (response) => {
          if (response.status === 200) {
            setLoadingServices(true);
            reject(response);
            setOpenModalRequestReject(false);
            closeModal();
            setOpenModalSatisfactionQuestionnaire(false);
          }
          return response;
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
          throw e;
        }
      );
    }
  }

  async function upImageInApproval(
    dataInApproval = [],
    serviceId = idService,
  ) {
    const data = {
      dataInApproval,
      idService: serviceId,
    }

    if (userStore.token) {
      try {
        const response = await maintenancesActions.insertImage(userStore.token, data);
        return response;

      } catch (e) {
        if (e.status === 401) {
          reject(e);
        }
      }
    }
  }


  function CustomToggle({ children, eventKey, handleClick }) {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      handleClick();
    });

    return (
      <div className="arrow-card" onClick={decoratedOnClick}>
        {children}
      </div>
    );
  }

  const openModalAccept = (id) => {
    setOpenModal(true);
    setIdService(id);
  };

  const openModalDeny = (id) => {
    setOpenModalLeft(true);
    setIdService(id);
  };

  const acceptModal = () => {
    setOpenModal(false);
    setShowBtnOption(false);
    setShowBtnCancel(true);
    update(idService, 'Accept', '', 2, '', '', true, '', '');
  };

  const acceptModalChangeInProcess = () => {
    setOpenModalChangeInProcess(false);
    update(idService, 'Accept', '', 3, '', '', true, '', '');
  };

  const acceptModalChangeInApproval = async () => {
    setOpenModalChangeInApproval(false);
    setMessageAlertInApproval(false);

    if (Object.keys(dataFormInApproval).length === 0
      || !dataFormInApproval[`kmOdometer_${idService}`]
      || !dataFormInApproval[`images1_${idService}`]
      || !dataFormInApproval[`images2_${idService}`]) {

      setMessageAlertInApproval(true);
    } else {
      const responseImages = await upImageInApproval(dataFormInApproval);
      if (responseImages) {
        await update(idService, 'Accept', '', 10, '', '', true, '', '', responseImages, dataFormInApproval[`kmOdometer_${idService}`]);
      } else {
        setTextMessageAlertInApproval(t('validateFile'));
        setMessageAlertInApproval(true);
      }
    }
  };

  const acceptModalSatisfactionQuestionnaire = () => {
    setOpenModalStars(true);
    setOpenModalSatisfactionQuestionnaire(false);
  };

  const acceptModalLeft = () => {
    setOpenModalLeft(false);
    setShowBtnCancel(false);
    setShowBtnOption(true);
    setOpenModalRequestReject(true);
    setIdService(idService);
  };

  function confirmCancel(id) {
    setIdService(id);
    setOpenModalCancel(true);
  }

  const onSubmit = (data, id) => {
    update(id, 'Deny', data.formDeny, 5, '', '', true, '', '');
  };

  const onSubmitSatisfactionQuestionnaire = async (data, id) => {
    setMessageQuestionnaire(false);
    try {
      const responseImages = await maintenancesActions.insertImage(userStore.token, data, id);
      if (responseImages && typeof responseImages === 'object' && Array.isArray(responseImages.file) && responseImages.file.length > 0) {
        await update(id, 'Finalized', '', 4, data.description, data.stars, true, '', '', null, null, responseImages.file, data.sistems);
      } else {
        setMessageQuestionnaire(true);
      }
    } catch (e) {
      setMessageQuestionnaire(true);
    }
  };
  function changeInProcess(id) {
    setOpenModalChangeInProcess(true);
    setIdService(id);
  }
  function changeInApproval(id) {
    setMessageAlertInApproval(false);
    setOpenModalChangeInApproval(true);
    setIdService(id);
  }

  const setDataFormAdditionalApproval = (data) => {
    dataFormAdditionalApprovalRef.current = data;
  };

  function openAdditionalApprovalModal(id) {
    idServiceRef.current = id;
    dataFormAdditionalApprovalRef.current = {};
    setMessageAlertAdditionalApproval(false);
    setOpenModalAdditionalApproval(true);
    setIdService(id);
  }

  const acceptModalAdditionalApproval = async () => {
    const formData = dataFormAdditionalApprovalRef.current;
    const currentIdService = idServiceRef.current;

    const i1 = formData[`images1_${currentIdService}`];
    const i2 = formData[`images2_${currentIdService}`];

    if (!Array.isArray(i1) || i1.length === 0 || !Array.isArray(i2) || i2.length === 0) {
      setMessageAlertAdditionalApproval(true);
      return;
    }

    // Cierra el modal primero (igual que acceptModalChangeInApproval)
    setOpenModalAdditionalApproval(false);
    setMessageAlertAdditionalApproval(false);

    const responseImages = await upImageInApproval(formData, currentIdService);
    if (!responseImages) {
      return;
    }

    if (userStore.token) {
      try {
        const result = await maintenancesActions.requestAdditionalApproval(userStore.token, {
          idService: currentIdService,
          imagesFiles: responseImages,
        });
        // BreadAPI wraps the response in { original: {...} }
        const success = result && (result.original ? result.original.success : result.success);
        if (success) {
          setLoadingServices(true);
        }
      } catch (e) {
        // 422 = backend limit reached (max 2 additional approvals)
        setTextMessageAlertInApproval(tMaintenance('max-additional-approvals'));
        setMessageAlertInApproval(true);
      }
    }
  };

  function satisfactionQuestionnaire(id) {
    setIdService(id);
    setOpenModalSatisfactionQuestionnaire(true, id);
  }

  const Toggle = React.forwardRef(({ children, onClick, eventKey }, ref) => (
    <button
      type="submit"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
        setArrow(!arrow);
        setActiveKeyStatus(eventKey);
      }}
    >
      {children}
    </button>
  ));

  CustomToggle.propTypes = {
    children: PropTypes.node.isRequired,
    eventKey: PropTypes.number.isRequired,
    handleClick: PropTypes.func.isRequired,
  };

  function onChangeInitial(date) {
    useSetDateInitial(date);
  }
  function onChangeFinal(date) {
    useSetDateFinal(date);
  }

  function newFilter() {
    useSetDateInitial(moment().subtract(1, 'years'));
    useSetDateFinal(moment());
    useSetFilterDate(true);
  }

  return {
    reload,
    maintenances,
    newMaintenances,
    openModal,
    openModalCancel,
    openModalChangeInProcess,
    openModalChangeInApproval,
    openModalSatisfactionQuestionnaire,
    openModalStars,
    openModalLeft,
    openModalRequestReject,
    openModalAccept,
    openModalDeny,
    closeModal,
    acceptModal,
    acceptModalChangeInProcess,
    acceptModalChangeInApproval,
    acceptModalSatisfactionQuestionnaire,
    acceptModalLeft,
    idService,
    onSubmit,
    onSubmitSatisfactionQuestionnaire,
    changeInProcess,
    changeInApproval,
    satisfactionQuestionnaire,
    dateInitial,
    dateFinal,
    useSetFilterDate,
    onChangeInitial,
    onChangeFinal,
    star,
    setStar,
    CustomToggle,
    Toggle,
    arrow,
    activeKeyStatus,
    confirmCancel,
    dataMaintenance,
    newFilter,
    dataGarage,
    messageAlertInApproval,
    textMessageAlertInApproval,
    messageQuestionnaire,
    setDataFormInApproval,
    openModalAdditionalApproval,
    openAdditionalApprovalModal,
    acceptModalAdditionalApproval,
    messageAlertAdditionalApproval,
    setDataFormAdditionalApproval,
  };
}

export default useStatusService;
